import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import axios from 'axios';

const initialState = {
    total: 0,
    pages: 0,
    current: 0,
    error: null,
    accounts: null,
    loading: false,
    lloading: false,
    withdrawals: null,
}

export const withdrawalReq = createAsyncThunk('withdrawalReq', async ({ data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/partner//withdraw/money`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const addBankReq = createAsyncThunk('addBankReq', async ({ data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/partner/add/bank-account`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(bankListReq({}))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const bankListReq = createAsyncThunk('bankListReq', async ({ }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/bank-account/list`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const withdradawalListReq = createAsyncThunk('withdradawalListReq', async ({ }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/withdraw/list`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const deleteBankReq = createAsyncThunk('deleteBankReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/partner/bank-account/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(bankListReq({}))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                    dispatch(bankListReq({}))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const BankSlice = createSlice({
    name: 'BankSlice',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(addBankReq.pending, (state, action) => {
            state.loading = true
            return state
        })
        builder.addCase(addBankReq.fulfilled, (state, action) => {
            state.loading = false
            return state
        })
        builder.addCase(addBankReq.rejected, (state, action) => {
            state.loading = false
            state.error = 'Error occured'
        })

        builder.addCase(bankListReq.pending, (state, action) => {
            state.lloading = true
            state.accounts = null
            return state
        })
        builder.addCase(bankListReq.fulfilled, (state, action) => {
            state.lloading = false
            state.accounts = action.payload?.data
            return state
        })
        builder.addCase(bankListReq.rejected, (state, action) => {
            state.lloading = false
            state.accounts = null
            state.error = 'Error occured'
        })

        builder.addCase(withdradawalListReq.pending, (state, action) => {
            state.loading = true
            state.withdrawals = null
            return state
        })
        builder.addCase(withdradawalListReq.fulfilled, (state, action) => {
            state.loading = false
            state.withdrawals = action.payload?.data
            return state
        })
        builder.addCase(withdradawalListReq.rejected, (state, action) => {
            state.loading = false
            state.withdrawals = null
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default BankSlice.reducer